export default "__VITE_ASSET__9e39f9ff__"